import { BRAND_BOOKINGS } from "../../actions/type";

export default function brandBooking(state = [], action) {
    switch (action.type) {
        case BRAND_BOOKINGS:
            return action.payload;;
        default:
            return state
    }
}